import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '@copro/api';
import { enqueueSnackbar } from '../../../components/GlobalSnackbar/snackbarStore';
import { keys } from './keys';

type Variables = {
  code: string;
  spaceId: string;
  redirectUri: string;
};

type Result = {
  success: boolean;
  googleEmail: string;
  rootFolderId: string;
  rootFolderName: string;
};

async function connectDrive(variables: Variables): Promise<Result> {
  const { data, error } = await apiClient.functions.invoke('google-drive-connect', {
    body: variables,
  });

  if (error) {
    throw error;
  }

  return data as Result;
}

export default function useConnectDrive() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: connectDrive,
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: keys.config(variables.spaceId) });
      enqueueSnackbar('Google Drive connecté avec succès.', 'success');
    },
    onError: (err: Error) => {
      enqueueSnackbar(err.message || 'Échec de la connexion à Google Drive.', 'error');
    },
  });
}
